import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'orgAssessmentV2',
    label: 'Organization Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
